import React from 'react';
import styled from 'styled-components';
import GeneralContext from '../contexts/GeneralContext';
import solutionsData from '../sharedData/SolutionsData';
import { pmWhite } from '../sharedData/Constants';

import User from '../assets/images/user.png';

import { MobileWidth } from '../sharedData/Constants';


const Introduction = () => {
    return(
        <GeneralContext.Provider value={solutionsData}>
            <StyledView>
                <StyledContainer>
                    <UserImg src={User} alt="Usuário" />
                    <Text>
                        Por conta disso, <span>os usuários passam a valorizar cada vez mais experiências de compra personalizadas,</span> que podem ser alcançadas através de recomendações de produtos baseadas em IA e segmentações mais precisas. <br></br><br></br>

                        Por fim, para se destacar nesta Black Friday, as marcas devem não só oferecer grandes descontos, mas também <span>criar uma experiência de compra memorável.</span><br></br><br></br>

                        Para esse ano, algumas tendências importantes no CRM estão crescendo, ajudando as empresas a maximizar suas vendas e engajamento com os clientes. <span>Confira a seguir as principais tendências:</span>
                    </Text>    
                </StyledContainer>
            </StyledView>
        </GeneralContext.Provider>
    );
};

const Text = styled.div`
    font-family: Work Sans;
    font-size: 20px;
    width: 537px;
    text-align: start;
    margin-top: 70px;
    span{
        font-weight: bold;
    }
    @media screen and (max-width: ${MobileWidth}){
        margin-top: 0px;
        width: 265px;
        font-size: 11px;
    }
`

const UserImg = styled.img`
  @media screen and (max-width: ${MobileWidth}) {
    display: none;
  }
`;

const StyledContainer = styled.div` 
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledView = styled.div` 
    display: flex;
    align-items: center;
    justify-content: center;
    height: 572px;
    background-color: ${pmWhite};
    @media screen and (max-width: ${MobileWidth}) {
        height: 306px;
    }
`;

export default Introduction;